import { SettingsSection } from '$common/settings-section'
import { CallOutlinedIcon, ContactIcon } from '$common/icons'
import { openInviteFromContacts, openInviteViaPhone } from '$logic/router'
import { t } from '$i18n'
import { InviteActionItem } from '../invite-action-item'

export function InviteActionBox({ limit }: { limit: number }) {
  return (
    <SettingsSection>
      <>
        <InviteActionItem
          Icon={<ContactIcon color="secondary" />}
          onClick={() => openInviteFromContacts(limit)}
        >
          {t('invite.inviteFromContacts')}
        </InviteActionItem>
        <InviteActionItem
          Icon={<CallOutlinedIcon color="secondary" />}
          onClick={openInviteViaPhone}
        >
          {t('invite.inviteViaPhone')}
        </InviteActionItem>
      </>
    </SettingsSection>
  )
}
